import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
// import {
//   useEditQuestionsMutation,
//   useGetQuestionsByIdQuery,
// } from "src/services/QuestionBankServices";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
import JobForm from "../Layout/JobForm";
import { JobBoardFormValues } from "src/models/JobBoard.model";
import {
  useEditJobMutation,
  useGetJobByIdQuery,
} from "src/services/JobBoardServices";
type Props = {
  onClose: () => void;
  jobId: string;
};

const EditJobFormWrapper = ({ onClose, jobId }: Props) => {
  const [saveNextChecked, setSaveNextChecked] = useState(true);
  const [jobData, setJobData] = useState<any>({});

  const [editJob] = useEditJobMutation();
  const { data, isLoading, isFetching } = useGetJobByIdQuery({
    id: jobId,
  });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setJobData(data?.data);
    }
  }, [data, isLoading, isFetching]);

  // Form Initial Values
  const initialValues: JobBoardFormValues = {
    JobRole: jobData?.jobRole || "",
    CompanyName: jobData?.companyName || "",
    JobType:
      {
        label: jobData?.jobType,
        value: jobData?.jobType,
      } || "",
    WorkMode:
      {
        label: jobData?.workMode,
        value: jobData?.workMode,
      } || "",
    requirements: jobData?.requirements || "",
    responsibilities: jobData?.responsibilities || "",
    jobLocation: jobData.jobLocation || "",
    benefitsAndPerks: jobData.benefitsAndPerks || "",
    aboutComapny: jobData.aboutComapny || "",
    Experience: jobData.Experience || "",
    companyLogo: jobData.companyLogo || "",
    jobLink: jobData?.jobLink || ''
  };

  // Validation Schema
  const validationSchema = object().shape({
    JobRole: string().required("Please enter job role"),
    JobType: object().required("Please select job type"),
    WorkMode: object().required("Please select work mode"),
    CompanyName: string().required("Please enter company name"),
    requirements: string().required("Please enter requirements"),
    responsibilities: string().required("Please enter responsibilities"),
  });

  // Handle Submit
  const handleSubmit = (
    values: JobBoardFormValues,
    { setSubmitting, resetForm }: FormikHelpers<JobBoardFormValues>
  ) => {
    const formatedValue = {
      jobRole: values.JobRole,
      companyName: values.CompanyName,
      jobType: values.JobType?.value,
      workMode: values.WorkMode?.value,
      requirements: values.requirements,
      responsibilities: values.responsibilities,
      jobLocation: values.jobLocation,
      benefitsAndPerks: values.benefitsAndPerks,
      aboutComapny: values.aboutComapny,
      Experience: values.Experience,
      companyLogo: values.companyLogo,
      jobLink: values.jobLink,
    };
    editJob({
      body: formatedValue,
      id: jobId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xl" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form className="h-full overflow-hidden contents">
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <JobForm
              formikProps={formikProps}
              onClose={onClose}
              formType="Edit"
              setSaveNextChecked={setSaveNextChecked}
              saveNextChecked={saveNextChecked}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditJobFormWrapper;
